module.exports = __webpack_public_path__ + "static/media/SEMBLANZA.41da2be6.pdf";